import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-jc-center kn-height-full" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = {
  key: 0,
  class: "p-grid p-offset-1"
}
const _hoisted_4 = { class: "p-col-9 p-md-9" }
const _hoisted_5 = { class: "p-col-3 p-md-3" }
const _hoisted_6 = {
  ref: "detail-form",
  class: "p-m-5"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-inputgroup" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { for: "userId" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { for: "fullName" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = { class: "p-inputgroup" }
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = { for: "password" }
const _hoisted_19 = { class: "p-field" }
const _hoisted_20 = { class: "p-inputgroup" }
const _hoisted_21 = { class: "p-float-label" }
const _hoisted_22 = { for: "passwordConfirm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, null, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.detail')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          (_ctx.userDetailsForm.failedLoginAttempts >= 3)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_InlineMessage, { severity: "warn" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.blockedUserInfo')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.unlockUser,
                    icon: "pi pi-lock-open",
                    label: _ctx.$t('managers.usersManagement.unlockUser')
                  }, null, 8, ["onClick", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("form", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_InputText, {
                    id: "userId",
                    maxlength: "100",
                    type: "text",
                    disabled: !_ctx.formInsert,
                    modelValue: _ctx.userDetailsForm.userId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userDetailsForm.userId = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDataChange(_ctx.vobj.userDetailsForm.userId))),
                    class: "p-inputtext p-component kn-material-input"
                  }, null, 8, ["disabled", "modelValue"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.usersManagement.form.userId')) + " *", 1)
                ])
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.vobj.userDetailsForm.userId,
                additionalTranslateParams: { fieldName: _ctx.$t('managers.usersManagement.form.userId') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, [
                  _createVNode(_component_InputText, {
                    id: "fullName",
                    maxlength: "250",
                    type: "text",
                    modelValue: _ctx.userDetailsForm.fullName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.userDetailsForm.fullName = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDataChange(_ctx.vobj.userDetailsForm.fullName))),
                    class: "p-inputtext p-component kn-material-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.usersManagement.fullName')) + " *", 1)
                ])
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.vobj.userDetailsForm.fullName,
                additionalTranslateParams: { fieldName: _ctx.$t('managers.usersManagement.fullName') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_InputText, {
                    id: "password",
                    type: "password",
                    modelValue: _ctx.userDetailsForm.password,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.userDetailsForm.password = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDataChange(_ctx.vobj.userDetailsForm.password))),
                    class: "p-inputtext p-component kn-material-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.usersManagement.form.password')) + " *", 1)
                ])
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.vobj.userDetailsForm.password,
                additionalTranslateParams: { fieldName: _ctx.$t('managers.usersManagement.form.password') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("span", _hoisted_21, [
                  _createVNode(_component_InputText, {
                    id: "passwordConfirm",
                    type: "password",
                    modelValue: _ctx.userDetailsForm.passwordConfirm,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.userDetailsForm.passwordConfirm = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onDataChange(_ctx.vobj.userDetailsForm.passwordConfirm))),
                    class: "p-inputtext p-component kn-material-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('managers.usersManagement.form.passwordConfirm')) + " *", 1)
                ])
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.vobj.userDetailsForm.passwordConfirm,
                additionalTranslateParams: { fieldName: _ctx.$t('managers.usersManagement.form.passwordConfirm') },
                specificTranslateKeys: { sameAsPassword: 'managers.usersManagement.validation.sameAsPassword' }
              }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
            ])
          ], 512)
        ]),
        _: 1
      })
    ])
  ]))
}